import { CourseCohort } from '@uac-au/advance-typings';
import { nonEmptyString } from 'schemas/common';
import { z } from 'zod';

export const courseSchema = z.object({
  ID: nonEmptyString,
  code: nonEmptyString,
  cohorts: z.array(z.nativeEnum(CourseCohort)),
  cricosCodes: z.array(nonEmptyString),
  name: nonEmptyString,
  url: nonEmptyString.nullable(),
});
